import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // <-- 1. IMPORT
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Navigation from './routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> {/* <-- 2. WRAP YOUR ROUTER */}
      <BrowserRouter>
        <Navigation />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();